import React from "react";
import { ToastContainer } from "react-toastify";
import AddBanner from "../../components/Settings/Banner/AddBanner";

export const AddBannerPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <AddBanner />
        </div>
      </div>
    </div>
  );
};
